/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'leave-session': {
    width: 16,
    height: 16,
    viewBox: '0 0 34 34',
    data: '<path pid="0" d="M22.7 22.7v2.7c0 2.5-2 4.5-4.5 4.5H4.5c-2.5 0-4.5-2-4.5-4.5V8.6c0-2.5 2-4.5 4.5-4.5h13.7c2.5 0 4.5 2 4.5 4.5v2.7c0 .6-.5 1.1-1.1 1.1s-1.1-.5-1.1-1.1V8.6c0-1.3-1-2.3-2.3-2.3H4.5c-1.3 0-2.3 1-2.3 2.3v16.7c0 1.3 1 2.3 2.3 2.3h13.7c1.3 0 2.3-1 2.3-2.3v-2.7c0-.6.5-1.1 1.1-1.1.6.1 1.1.6 1.1 1.2zm11-6.5L28 10.6c-.4-.4-1.1-.4-1.6 0-.2.2-.3.5-.3.8 0 .3.1.6.3.8l3.8 3.8h-15c-.6 0-1.1.5-1.1 1.1s.5 1.1 1.1 1.1h15.1L26.5 22c-.2.2-.3.5-.3.8 0 .3.1.6.3.8.2.2.5.3.8.3.3 0 .6-.1.8-.3l5.7-5.7c.2-.2.3-.5.3-.8s-.2-.7-.4-.9z"/>'
  }
})
